import * as React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { useDispatch } from "react-redux";
import IconButton from "@mui/material/IconButton";
import FileOpenIcon from "@mui/icons-material/FileOpen";
import { Button } from "@mui/material";

export const SubjectPagePDFItem = (props) => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const dispatch = useDispatch();

  const { _id, pdfUrl, title, description } = props.pdf;

  return (
    <div>
      <Card
        sx={{
          margin: "10px",
          boxShadow: "10px 10px 10px 10px rgba(0,0,0,0.2)",
        }}
      >
        {/* <CardMedia sx={{ height: 240 }} image={heroImg} title="green iguana" /> */}
        {/* <VedioPlayer
          url={videoUrl}
          watchTime={watchTime}
          updateWatchTimes={updateWatchTimes}
        /> */}
        <embed
          src={pdfUrl}
          type="application/pdf"
          width={"100%"}
          height={200}
          style={{ overflow: "hidden !important" }}
        />
        <CardContent>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography gutterBottom variant="h5" component="div">
              {title}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {description}
            </Typography>
          </div>

          <a href={pdfUrl} download target="_blank">
            <Button variant="contained" color="primary">
              View Tute
            </Button>
          </a>
        </CardContent>
      </Card>
    </div>
  );
};
